<template>
  <warehousing-in-stack lob="AE" />
</template>

<script>
import WarehousingInStack from '@/components/Cargo/Warehouse/warehousingInStack'
export default {
  name: 'AEWarehousing',
  components: { WarehousingInStack }
}
</script>

<style scoped>

</style>
